import chinaFlag from "../static/svgs/chinaFlag.svg";
import usaFlag from "../static/svgs/usaFlag.svg";

const intlConstants = {
  INTL_COUNTRIES: { CO: false, CL: true, PE: true },
  CHINA_CODE: "cn",
  HONG_KONG_CODE: "HK",
  HONG_KONG_NAME: "hong kong",
  COLOMBIA_CODE: "CO",
  VALID_COUNTRIES_INTL: {
    CN: {
      id: "49",
      countryCode: "CN",
      name: "China",
      logo: chinaFlag
    },
    US: {
      id: "231",
      countryCode: "US",
      name: "United States",
      logo: usaFlag
    }
  },
  INTL_DOC_ADMIN_VALIDATIONS: {
    dni: {
      maxLength: 18,
      minLength: 5
    },
    dl: {
      maxLength: 16,
      minLength: 5
    },
    pas: {
      maxLength: 9,
      minLength: 5
    }
  },
  INTL_WAREHOUSE: {
    CL: {
      countryReturnWarehouse: "Chile",
      addressReturnWarehouse: "Av. Lo Espejo 3200, Andén 94 CD Tradis, Cerrillos, Santiago, Chile",
      regionReturnWarehouse: "Metropolitana de Santiago",
      cityReturnWarehouse: "Santiago",
      municipalReturnWarehouse: "Cerrillos",
      postalCodeReturnWarehouse: 9200000,
      Address2codeReturnWarehouse: 13102,
      coordinatesReturnWarehouse: { lat: "-33.5290041", lng: "-70.7114304" }
    },
    PE: {
      countryReturnWarehouse: "Perú",
      addressReturnWarehouse:
        "CAR. PANAMERICANA SUR KM 215 LOTE 17 Y 18 UNIDAD CATASTRAL 10050 ALDEA LOGISTIC GLOBAL #6",
      regionReturnWarehouse: "Lima",
      cityReturnWarehouse: "Lima",
      municipalReturnWarehouse: "Villa El Salvador",
      postalCodeReturnWarehouse: 15834,
      Address2codeReturnWarehouse: 150142,
      coordinatesReturnWarehouse: { lat: "-12.217302040897783", lng: "-76.95774259662149" }
    },
    CO: {
      countryReturnWarehouse: "Colombia",
      addressReturnWarehouse: "Example address 123, Bogotá",
      regionReturnWarehouse: "Centro Oriente",
      cityReturnWarehouse: "Centro Oriente",
      municipalReturnWarehouse: "Bogotá",
      postalCodeReturnWarehouse: 110911,
      Address2codeReturnWarehouse: 11001,
      coordinatesReturnWarehouse: { lat: "4.709136821134444", lng: "-74.07013280330278" }
    }
  },
  INTL_WAREHOUSE_CONTACT: {
    CL: {
      returnWarehouseContactName: "Mariagnny Gonzalez",
      returnWarehouseContactPhone: "942860094",
      returnWarehouseContactEmail: "ProcesosHD@falabella.onmicrosoft.com"
    },
    PE: {
      returnWarehouseContactName: "Pedro Arias",
      returnWarehouseContactPhone: "941364565",
      returnWarehouseContactEmail: "inversawhhdperu@falabella.com"
    },
    CO: {
      returnWarehouseContactName: "Test User",
      returnWarehouseContactPhone: "123456789",
      returnWarehouseContactEmail: "testfaco@falabella.com"
    }
  },
  COUNTRY_DATA: {
    CL: {
      id: "47",
      iso2Code: "CL",
      name: "Chile"
    },
    PE: {
      id: "174",
      iso2Code: "PE",
      name: "Perú"
    },
    CO: {
      id: "50",
      iso2Code: "CO",
      name: "Colombia"
    },
    CN: {
      id: "49",
      iso2Code: "CN",
      name: "China"
    },
    US: {
      id: "231",
      iso2Code: "US",
      name: "United States"
    }
  },
  COUNTRY_VALIDATIONS: [
    {
      name: "China",
      label: "China",
      code: "CN",
      value: "CN",
      id: 49,
      dniValidations: {
        maxLength: 18,
        minLength: 5
      },
      dlValidations: {
        maxLength: 18,
        minLength: 5
      },
      pasValidations: {
        maxLength: 18,
        minLength: 5
      }
    },
    {
      name: "United States",
      label: "United States",
      code: "US",
      value: "US",
      id: 231,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 13,
        minLength: 5
      },
      pasValidations: {
        maxLength: 13,
        minLength: 5
      }
    },
    {
      name: "Chile",
      label: "Chile",
      code: "CL",
      value: "CL",
      id: 47,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 9,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Mexico",
      label: "Mexico",
      code: "MX",
      value: "MX",
      id: 157,
      dniValidations: {
        maxLength: 18,
        minLength: 5
      },
      dlValidations: {
        maxLength: 13,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Colombia",
      label: "Colombia",
      code: "CO",
      value: "CO",
      id: 50,
      dniValidations: {
        maxLength: 10,
        minLength: 5
      },
      dlValidations: {
        maxLength: 10,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Panama",
      label: "Panama",
      code: "PA",
      value: "PA",
      id: 173,
      dniValidations: {
        maxLength: 11,
        minLength: 5
      },
      dlValidations: {
        maxLength: 9,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Peru",
      label: "Peru",
      code: "PE",
      value: "PE",
      id: 174,
      dniValidations: {
        maxLength: 8,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Spain",
      label: "Spain",
      code: "ES",
      value: "ES",
      id: 68,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 9,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Italy",
      label: "Italy",
      code: "IT",
      value: "IT",
      id: 110,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 10,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Brazil",
      label: "Brazil",
      code: "BR",
      value: "BR",
      id: 32,
      dniValidations: {
        maxLength: 11,
        minLength: 5
      },
      dlValidations: {
        maxLength: 11,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "United Kingdom",
      label: "United Kingdom",
      code: "GB",
      value: "GB",
      id: 77,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 16,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "South Korea",
      label: "South Korea",
      code: "KR",
      value: "KR",
      id: 122,
      dniValidations: {
        maxLength: 13,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Argentina",
      label: "Argentina",
      code: "AR",
      value: "AR",
      id: 12,
      dniValidations: {
        maxLength: 11,
        minLength: 5
      },
      dlValidations: {
        maxLength: 10,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "France",
      label: "France",
      code: "FR",
      value: "FR",
      id: 75,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Taiwan",
      label: "Taiwan",
      code: "TW",
      value: "TW",
      id: 226,
      dniValidations: {
        maxLength: 10,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Malaysia",
      label: "Malaysia",
      code: "MY",
      value: "MY",
      id: 158,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Uruguay",
      label: "Uruguay",
      code: "UY",
      value: "UY",
      id: 232,
      dniValidations: {
        maxLength: 8,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Venezuela",
      label: "Venezuela",
      code: "VE",
      value: "VE",
      id: 236,
      dniValidations: {
        maxLength: 10,
        minLength: 5
      },
      dlValidations: {
        maxLength: 10,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Costa Rica",
      label: "Costa Rica",
      code: "CR",
      value: "CR",
      id: 51,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 9,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Czech Republic",
      label: "Czech Republic",
      code: "CZ",
      value: "CZ",
      id: 56,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Ecuador",
      label: "Ecuador",
      code: "EC",
      value: "EC",
      id: 63,
      dniValidations: {
        maxLength: 10,
        minLength: 5
      },
      dlValidations: {
        maxLength: 10,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Israel",
      label: "Israel",
      code: "IL",
      value: "IL",
      id: 103,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "India",
      label: "India",
      code: "IN",
      value: "IN",
      id: 105,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 15,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Japan",
      label: "Japan",
      code: "JP",
      value: "JP",
      id: 114,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Cambodia",
      label: "Cambodia",
      code: "KH",
      value: "KH",
      id: 117,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Macau",
      label: "Macau",
      code: "MO",
      value: "MO",
      id: 148,
      dniValidations: {
        maxLength: 8,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Mauritius",
      label: "Mauritius",
      code: "MU",
      value: "MU",
      id: 154,
      dniValidations: {
        maxLength: 14,
        minLength: 5
      },
      dlValidations: {
        maxLength: 14,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Singapore",
      label: "Singapore",
      code: "SG",
      value: "SG",
      id: 198,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Turkey",
      label: "Turkey",
      code: "TR",
      value: "TR",
      id: 223,
      dniValidations: {
        maxLength: 11,
        minLength: 5
      },
      dlValidations: {
        maxLength: 15,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Ukraine",
      label: "Ukraine",
      code: "UA",
      value: "UA",
      id: 228,
      dniValidations: {
        maxLength: 9,
        minLength: 5
      },
      dlValidations: {
        maxLength: 8,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    },
    {
      name: "Zimbabwe",
      label: "Zimbabwe",
      code: "ZW",
      value: "ZW",
      id: 247,
      dniValidations: {
        maxLength: 12,
        minLength: 5
      },
      dlValidations: {
        maxLength: 12,
        minLength: 5
      },
      pasValidations: {
        maxLength: 9,
        minLength: 5
      }
    }
  ],
  SUPPORT_EMAIL: "sellersupportimp@falabella.com"
};

export default Object.freeze(intlConstants);
